import { ReactNode, createContext } from "react";

import { VcsProvider } from "types/generated";

import useGetDefaultVcsIntegration from "./useGetDefaultVcsIntegration";

type VCSIntegrationsListContextProps = {
  isDefaultIntegrationsLoading: boolean;
  isSetupDisabled: (provider: VcsProvider) => boolean;
  refetchDefaultIntegrations: () => void;
  refetchIntegrations: () => void;
};

export const VCSIntegrationsListContext = createContext<
  VCSIntegrationsListContextProps | undefined
>(undefined);
VCSIntegrationsListContext.displayName = "VCSIntegrationsListContext";

type VCSIntegrationsListContextProviderProps = {
  children: ReactNode;
  refetchIntegrations: () => void;
};

export const VCSIntegrationsListContextProvider = ({
  children,
  refetchIntegrations,
}: VCSIntegrationsListContextProviderProps) => {
  const { loading, isSetupDisabled, refetchDefaultIntegrations } = useGetDefaultVcsIntegration();

  return (
    <VCSIntegrationsListContext.Provider
      value={{
        isDefaultIntegrationsLoading: loading,
        isSetupDisabled,
        refetchDefaultIntegrations,
        refetchIntegrations,
      }}
    >
      {children}
    </VCSIntegrationsListContext.Provider>
  );
};
